import React from "react";
import styles from "./Warning.module.scss";
import WarningIcon from "../../assets/icons/WarningIcon";
import ExitIcon from "../../assets/icons/ExitIcon";
import { useTranslation } from "react-i18next";

const Warning = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.warningBg}>
      <div className={styles.warningContainer}>
        <div className={styles.warning}>
          <WarningIcon />
          <p className={styles.warningContent}>
            {t("warningContent")} <span>{t("support")}</span>
          </p>
        </div>

        <ExitIcon />
      </div>
    </div>
  );
};

export default Warning;
